import React from 'react';
import { motion } from 'framer-motion';
import { CardProps } from '../../types';

const AnimatedCard: React.FC<CardProps> = ({
                                               className = '',
                                               children,
                                               hover = true,
                                               glow = false,
                                               glass = false,
                                               onClick,
                                           }) => {
    const baseClasses = 'rounded-xl p-6 md:p-8';
    const glassClasses = glass ? 'glass' : 'bg-white shadow-lg';
    const hoverClasses = hover ? 'card-hover' : '';
    const glowClasses = glow ? 'card-glow' : '';
    const clickableClasses = onClick ? 'cursor-pointer' : '';

    return (
        <motion.div
            className={`${baseClasses} ${glassClasses} ${hoverClasses} ${glowClasses} ${clickableClasses} ${className}`}
            onClick={onClick}
            whileHover={hover ? { scale: 1.02 } : {}}
            whileTap={onClick ? { scale: 0.98 } : {}}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{
                duration: 0.5,
                ease: [0.19, 1, 0.22, 1],
            }}
        >
            {children}
        </motion.div>
    );
};

export default AnimatedCard;